import React, { FunctionComponent } from 'react';
import { Grid, Typography } from '@rbx/ui';
import { useTranslation } from '@rbx/intl';
import StandardMarkdown from '@modules/ui/markdown/components/StandardMarkdown';
import OpenCloudAPIObject from '../../../utils/interfaces/OpenCloudAPIObject';
import AttributeTable from './AttributeTable';
import useObjectContainerStyles from './ObjectContainer.styles';

export interface ObjectContainerProps {
  object: OpenCloudAPIObject;
}

const ObjectContainer: FunctionComponent<React.PropsWithChildren<ObjectContainerProps>> = ({
  object: { name, content },
}) => {
  const schemaDescription = content.description;

  const { translate } = useTranslation();

  const {
    classes: { descriptionContainer, attributesHeader },
  } = useObjectContainerStyles();

  return (
    <Grid container direction='column'>
      <Grid item XSmall>
        <Typography variant='h3' component='h3' id={name}>
          {name}
        </Typography>
      </Grid>
      <Grid item XSmall className={descriptionContainer}>
        {schemaDescription && <StandardMarkdown>{schemaDescription}</StandardMarkdown>}
      </Grid>
      <Grid item XSmall className={attributesHeader}>
        <Typography variant='h4' component='h4'>
          {translate('Label.Attributes')}
        </Typography>
      </Grid>
      <Grid item XSmall>
        <AttributeTable schema={content} />
      </Grid>
    </Grid>
  );
};

export default ObjectContainer;
